import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Ban } from "lucide-react";
import { mySalaryHold } from "../../api/salaryHolds";

// بانر للموظف: راتبك موقوف بسبب الغياب المتكرر + أيام الغياب وتاريخ الإيقاف.
export const MyHoldBanner = () => {
  const { t } = useTranslation();
  const [hold, setHold] = useState(null);

  useEffect(() => {
    mySalaryHold().then((res) => setHold(res.held ? res : null)).catch(() => {});
  }, []);

  if (!hold) return null;
  const days = hold.absence_days || [];
  return (
    <div className="rounded-3xl border-2 border-red-300 bg-red-50 p-5" data-testid="my-salary-hold">
      <p className="flex items-center gap-2 text-base font-black text-red-700">
        <Ban className="h-5 w-5" /> {t("holds.myHeldTitle")}
      </p>
      <p className="mt-2 text-sm font-semibold text-red-900">
        {t("holds.myHeldBody", { count: days.length })}
      </p>
      <div className="mt-3 flex flex-wrap items-center gap-2 text-[11px]">
        <span className="font-bold text-red-800">{t("holds.myHeldDays")}:</span>
        {days.map((day) => (
          <span key={day} className="rounded-full bg-white px-2 py-1 font-mono text-red-700" dir="ltr">{day}</span>
        ))}
        <span className="font-bold text-red-800">
          · {t("holds.heldAt")}: {String(hold.held_at || "").slice(0, 10)}
        </span>
      </div>
    </div>
  );
};
